import colors from '../colors';
const colorModes = {
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 */
    actionBarTheme: {
        colors: {
            'page-gray': colors.plum,
            bluesuedeshoes: colors.white,
            black: colors.white,
        },
    },
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 */
    navigationMenuTheme: {
        colors: {
            bluesuedeshoes: colors.white,
            'light-gray': colors.plum,
            'patina-3': colors['slate-3'],
            'slate-5': colors.white,
        },
    },
};
export default colorModes;
//# sourceMappingURL=colorModes.js.map